// extracted by mini-css-extract-plugin
export var returnButton = "betalinggeannuleerd-module--return-button--9bd16";